const info={
    ZH: {  //中文翻译
     yue:"账户余额",
     login:"退出登录",
     apply:"申请邮寄",
    timer:"创建时间",
    zong:"总计（件）",
    renlin:"认领",
    allD:"全部订单",
    checks:"查询",
    order:"订单号",
    zhuan:"转单号",
    xiangqing:"订单详情",
    noMove:"没有更多了",
    look:"查看详情",
    address:"仓库地址",
    detail:"仓库详情",
    wareName:"仓库名称",
    countrys:"国家",
    xuanz:"选择国家",
    eara:"州省",
    citys:"城市",
    addressee:"收件人",
    youbian:"邮编",
    tel:"电话",
    phone:"手机",
    zhuangtai:"状态",
    baoguoh:"包裹号",
    xiangxi:"商品详细信息",
    baoxin:"包裹信息",
    chinese:"中文品名",
    en:"英文品名",
    pei:"配货",
    youji:"邮寄详情",
    fu:"附件预览",
    gong:"共",
    quan:"全选",
    shenC:"生成订单",
    shops:"商品订单信息",
    packType:"包裹类型",
    pack:"包裹",
    wenjian:"文件",
    PA:"PAK袋",
    dian:"电池类型",
    baoxian:"保险",
    COPY:"点击复制",
    dizhi1:"地址1",
    dizhi2:"地址2",
    dizhi3:"地址3",
    XIUGAI:"修改订单",
    },  
    EN: {  //英文翻译
        yue:"Account balance",
     login:"Log out",
     apply:"Application mailing",
    timer:"Creation time",
    zong:"Total (PCs.)",
    renlin:"Claim",
    allD:"All orders",
    checks:"check",
    order:"order number",
    zhuan:"Transfer order",
    xiangqing:"Order details",
    noMove:"No more",
    address:"Warehouse address",
    detail:"Warehouse details",
    wareName:"Warehouse name",
    countrys:"country",
    eara:"State and province",
    citys:"city",
    addressee:"addressee",
    youbian:"Zip code",
    tel:"Telephone",
    phone:"mobile phone",
    look:"View details",
    zhuangtai:"status",
    baoguoh:"Package number",
    xiangxi:"Product details",
    baoxin:"Package information",
    chinese:"Chinese name",
    en:"English name",
    pei:"Distribution",
    youji:"Mailing details",
    fu:"Attachment Preview",     
    gong:"共",
    quan:"SelectAll",
    shenC:"Generate order",
    shops:"Product order information",
    packType:"Package type",
    pack:"package",
    wenjian:"file",
    PA:"Pak bag",
    dian:"Battery type",
    baoxian:"Insurance",
    COPY:"copy",
    dizhi1:"address1",
    dizhi2:"address1",
    dizhi3:"address1",
    xuanz:"Select country",
    XIUGAI:"Modify order",

    }
}
export default info